<template>
  <printBase ref="LinkQR013" :title='title' :page='page' :width='800'>
    <div v-for="(pageList, pageIndex) in printInfoList" :key="pageIndex" :slot="page==1? 'content' : `content${pageIndex+1}`" class="printLinkQR">
      <div class="printTitle">药品陈列养护检查记录</div>
      <table style="width: 100%" class='printContent' border='1' cellspacing="0">
        <tr>
          <th style="width: 14%;">品名</th>
          <th style="width: 7%;">规格</th>
          <th style="width: 15%;">批准文号</th>
          <th style="width: 7%;">剂型</th>
          <th style="width: 5%;">数量</th>
          <th style="width: 13%;">生产企业</th>
          <th style="width: 10%;">批号</th>
          <th style="width: 10%;">有效期至</th>
          <th style="width: 9%;">质量状况</th>
          <th style="width: 9%;">结论</th>
        </tr>
        <tbody>
          <tr v-for="(item, printIndex) in pageList" :key="printIndex">
            <td><span>{{ item.curingRecordApprovedDrugNames }}</span></td>
            <td><span>{{ item.curingRecordSpecifications }}</span></td>
            <td><span>{{ item.inventoryInfoApprovalNumber }}</span></td>
            <td><span>{{ item.curingRecordDosageForm}}</span></td>
            <td><span>{{ item.curingRecordCuringCount }}</span></td>
            <td><span>{{ item.curingRecordManufacturer }}</span></td>
            <td><span>{{ item.curingRecordGoodsBatchNumber }}</span></td>
            <td><span>{{ item.inventoryInfoGoodsExpiryDate }}</span></td>
            <td><span>{{ item.curingRecordDoubtfulCount > 0 ? item.curingRecordCuringResultStr : '合格' }}</span></td>
            <td><span>{{ item.curingRecordCuringResultStr }}</span></td>
          </tr>
        </tbody>
      </table>
      <div>
          <span>养护员：{{pageList.curingName }}</span>
          <span style="margin-left:100px;">养护时间：{{pageList.curingDate }}</span>
        </div>
    </div>
  </printBase>
</template>
<script>
import _ from 'lodash';
import printBase from './printBase';
import utils from '../../libs/utils';

export default {
  data() {
    return {
      title: 'Link-QR-013',
      printInfoList: [],
      page: 1,
      pageSize: 25,
    };
  },
  components: {
    printBase,
  },
  methods: {
    handlePrint(value) {
      console.log(value);
      const infoList = [];
      // debugger;
      value.forEach((item) => {
        const result = {};
        utils.exchangeTable(item, result);
        result.curingRecordModifiedTime = utils.exchangeTime(result.curingRecordModifiedTime);
        result.inventoryInfoGoodsExpiryDate = utils.exchangeTime(result.inventoryInfoGoodsExpiryDate);
        result.curingRecordCuringResultStr = `${utils.fixNumber(result.curingRecordCuringCount - result.curingRecordDoubtfulCount, 2) || 0}合格, ${result.curingRecordDoubtfulCount || 0}存疑`;
        infoList.push(result);
      });
      this.printInfoList = _.chunk(infoList, this.pageSize);

      this.printInfoList.forEach((element) => {
        element.curingNameList = [];
        element.curingDateList = [];
        element.curingName = '';
        element.curingDate = '';
        element.forEach((elem) => {
          if (!element.curingNameList.includes(elem.curingRecordModifiedUserName)) {
            element.curingNameList.push(elem.curingRecordModifiedUserName);
          }
          if (!element.curingDateList.includes(elem.curingRecordModifiedTime)) {
            element.curingDateList.push(elem.curingRecordModifiedTime);
          }
        });
        element.curingNameList.forEach((nameItem) => {
          if (element.curingName) {
            element.curingName += `,${nameItem}`;
          } else {
            element.curingName += `${nameItem}`;
          }
        });
        element.curingDateList.forEach((dateItem) => {
          if (element.curingDate) {
            element.curingDate += `,${dateItem}`;
          } else {
            element.curingDate += `${dateItem}`;
          }
        });
      });
      this.page = this.printInfoList.length;
      this.$nextTick(() => {
        console.log(this.printInfoList);
        this.$refs.LinkQR013.handlePrint();
      });
    },
  },
  mounted() {
    this.page = this.printInfoList.length;
  },
};
</script>
<style lang="less" scoped>
.printContent td,th{
    text-align: center;
    position: relative;
    border-color: #000;
    font-weight: 300;
    word-break: break-all;
    padding: 2px 6px;
    font-size: 12px;
    *{
      display: inline-block;
      height: 32px;
      max-height: 32px;
      overflow:hidden
    }

  }
</style>
